import React, { useEffect, useState } from "react";
import "./BeeBanner.css";
import bees from '../assets/img/bees.jpg';
import beezim from '../assets/img/bee-zim.jpg';

const BeeBanner = () => {
      const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
      }, []);
  return (
    <div className="bee-wrapper" 
     style={{
        width: isMobile ? "80%" : "90%",
        margin: "0 auto", // centers the wrapper
        padding: "10px",  // inner padding
      }}>
      <div className="bee-container"
      >
        {/* Left Section */}
        <div className="bee-section bee-yellow">
          <div className="bee-box">
            <div className="bee-images">
              <img
                src={bees}
                alt="bee1"
              />
             
            </div>
            <div className="bee-text yellow-text">“Bee” the best!!!</div>
          </div>
        </div>

        {/* Right Section */}
        <div className="bee-section bee-purple">
          <div className="bee-box">
            <div className="bee-text purple-text">“Bee” better!!!</div>
            <div className="bee-images">
              <img
                src={beezim}
                alt="strong bee"
                className="strong-bee"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeeBanner;
